module.exports = __webpack_public_path__ + "img/funnel_2.fdd4e10d.png";